/**
 * Inserts or updates given item in items
 * @param idKey
 * @param items
 * @param item
 */
export const replaceOrInsertItem = <
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData
>(
  idKey: TIdKey,
  items: TData[],
  item: TData,
) => {
  const idx = items.findIndex(d => d[idKey] === item[idKey]);

  // Replace existing
  if (idx >= 0) {
    items[idx] = {...item};
  } else {
    items.push(item);
  }
};
